var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-header',{staticClass:"pb-5"},[_c('b-row',{staticClass:"py-0 px-0",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"7","lg":"6"}},[_c('nav',{staticClass:"d-none d-md-inline-block",attrs:{"aria-label":"breadcrumb"}})])],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }